
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import type { GetStaticProps, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { Download } from '../components/Download';

function Files() {
  const { locale } = useRouter();
  const { t } = useTranslation();
  return (
    <div className='w-full '>
      <div className='align-left mx-auto max-w-lg'>
        <Download
          link={'/terms-' + locale + '.pdf'}
          title={t('common:Terms and conditions')}
        />
        <hr />
        <Download
          link={'/terms-of-purchase-' + locale + '.pdf'}
          title={t('common:General Terms of Purchase')}
        />
      </div>
    </div>
  );
}

const JobsPage: NextPage = function () {
  const { t } = useTranslation();
  return (
    <div className='p-container flex flex-col items-center bg-white'>
      <div className='mb-8 max-w-7xl bg-white '>
        <div className='flex flex-col justify-center space-y-4 lg:pb-16'>
          <h4 className='title'>{t('common:Terms and conditions')}</h4>
          <h3 className='subtitle'>{t('common:terms subtitle')}</h3>
        </div>
      </div>
      <hr className='w-full ' />
      <Files />
    </div>
  );
};

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default JobsPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/terms-and-conditions',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  